__turbopack_context__.v({
  "innerWrapper": "eovNMG_innerWrapper",
  "wrapper": "eovNMG_wrapper",
});
